import { createContext } from 'react';
import {
  ParagraphFarmCategoryFragment,
  TermCategoryFragment,
} from '../generated/types';

interface SearchContextType {
  activeFilter?: TermCategoryFragment[];
  searchMoreFilter?: ParagraphFarmCategoryFragment[];
}

export const SearchContext = createContext<SearchContextType>({});
